// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ---- Page (club / BrandContext: --brand-*) ---- */
.TrainingSummary_page__IZAcO {
  min-height: 100vh;
  font-family:
    var(--brand-font),
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  color: var(--brand-text);
  background: linear-gradient(
    135deg,
    rgba(var(--brand-primary-rgb), 0.08) 0%,
    rgba(var(--brand-primary-rgb), 0.02) 42%,
    var(--brand-bg) 72%
  );
  background-color: var(--brand-bg);
}

/* Full-screen states (loaders, errors) — same shell as club home tone */
.TrainingSummary_fullPageShell__AV4i4 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    135deg,
    rgba(var(--brand-primary-rgb), 0.08) 0%,
    rgba(var(--brand-primary-rgb), 0.02) 42%,
    var(--brand-bg) 72%
  );
  background-color: var(--brand-bg);
}

.TrainingSummary_fullPageShellPadded__yqgHM {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(
    135deg,
    rgba(var(--brand-primary-rgb), 0.08) 0%,
    rgba(var(--brand-primary-rgb), 0.02) 42%,
    var(--brand-bg) 72%
  );
  background-color: var(--brand-bg);
}

.TrainingSummary_fullPageStack__auLTi {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 24px;
  background: linear-gradient(
    135deg,
    rgba(var(--brand-primary-rgb), 0.08) 0%,
    rgba(var(--brand-primary-rgb), 0.02) 42%,
    var(--brand-bg) 72%
  );
  background-color: var(--brand-bg);
}

.TrainingSummary_shellMessage__iTYR3 {
  margin: 0;
  color: var(--brand-text-secondary);
  text-align: center;
}

.TrainingSummary_primaryCta__nLFoY {
  padding: 10px 20px;
  background: var(--brand-primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: var(--brand-font), sans-serif;
  font-weight: 600;
  font-size: 0.95rem;
}

.TrainingSummary_primaryCta__nLFoY:hover {
  background: var(--brand-primary-dark);
}

.TrainingSummary_container__jaWfQ {
  max-width: 480px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.TrainingSummary_coachPlayerSelect__Y8p5b {
  margin-bottom: 16px;
  text-align: left;
}

.TrainingSummary_coachPlayerSelect__Y8p5b label {
  font-size: 12px;
  font-weight: 700;
  color: var(--brand-text-secondary);
  display: block;
  margin-bottom: 6px;
}

.TrainingSummary_coachPlayerSelectHint__N1nh8 {
  margin-top: 10px;
  font-size: 12px;
  line-height: 1.45;
  color: var(--brand-text-secondary);
}

/* Session context + exercise prev/next (Training Summary page) */
.TrainingSummary_sessionContextStack__audtR {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.TrainingSummary_exerciseNav__ObIJR {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  background: var(--brand-surface);
  border-radius: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(var(--brand-primary-rgb), 0.12);
}

.TrainingSummary_exerciseNavLoading__iWAts {
  grid-column: 1 / -1;
  text-align: center;
  font-size: 13px;
  color: var(--brand-text-secondary);
}

.TrainingSummary_exerciseNavBtn__4jIWP {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 40px;
  padding: 8px 10px;
  border: 1px solid rgba(var(--brand-primary-rgb), 0.35);
  border-radius: 8px;
  background: #fff;
  color: var(--brand-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: var(--brand-font), sans-serif;
}

.TrainingSummary_exerciseNavBtn__4jIWP:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.TrainingSummary_exerciseNavBtn__4jIWP:not(:disabled):hover {
  background: rgba(var(--brand-primary-rgb), 0.08);
}

.TrainingSummary_exerciseNavBtnLabel__mnZgb {
  display: none;
}

@media (min-width: 380px) {
  .TrainingSummary_exerciseNavBtnLabel__mnZgb {
    display: inline;
  }
}

.TrainingSummary_exerciseNavCenter__J7Qum {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-width: 0;
  text-align: center;
}

.TrainingSummary_exerciseNavPos__yxRRp {
  font-size: 12px;
  font-weight: 700;
  color: var(--brand-primary);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.TrainingSummary_exerciseNavName__GimxB {
  font-size: 14px;
  font-weight: 600;
  color: var(--brand-text);
  line-height: 1.3;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TrainingSummary_exerciseNavJump__sd5vf {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  width: 100%;
  max-width: 220px;
}

.TrainingSummary_exerciseNavJumpLabel__0qz0H {
  font-size: 11px;
  color: var(--brand-text-secondary);
}

.TrainingSummary_exerciseNavSelect__7jBNe {
  width: 100%;
  padding: 6px 8px;
  border-radius: 8px;
  border: 1px solid rgba(var(--brand-primary-rgb), 0.25);
  font-size: 13px;
  font-family: var(--brand-font), sans-serif;
  color: var(--brand-text);
  background: #fff;
}

@media (max-width: 420px) {
  .TrainingSummary_exerciseNav__ObIJR {
    grid-template-columns: 44px 1fr 44px;
  }

  .TrainingSummary_exerciseNavBtn__4jIWP {
    padding: 8px;
    min-width: 44px;
  }
}

/* ---- Header ---- */
.TrainingSummary_header__Uoqk5 {
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.TrainingSummary_iconBtn__ktz\\+i {
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: var(--brand-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}

.TrainingSummary_iconBtn__ktz\\+i:hover {
  background: rgba(var(--brand-primary-rgb), 0.1);
}

.TrainingSummary_title__\\+Gq8u {
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  color: var(--brand-text);
  margin: 0;
}

/* ---- Generic card ---- */
.TrainingSummary_card__bp222 {
  background: var(--brand-surface);
  border-radius: 12px;
  border: 1px solid rgba(var(--brand-primary-rgb), 0.12);
  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);
  padding: 16px;
}

/* ---- Exercise summary card ---- */
.TrainingSummary_summaryCard__2bnFJ {
  text-align: center;
}

.TrainingSummary_summaryTitle__nFGQj {
  font-size: 18px;
  font-weight: 700;
  color: var(--brand-text);
  margin: 0 0 8px;
}

.TrainingSummary_summaryType__scRAw,
.TrainingSummary_summarySubtype__D6bF- {
  font-size: 14px;
  color: var(--brand-text-secondary);
  margin: 0;
}

.TrainingSummary_summaryDate__Hle40 {
  font-size: 14px;
  color: var(--brand-text-secondary);
  margin-top: 12px;
}

/* ---- Metric grid ---- */
.TrainingSummary_metricsGrid__\\+W6wr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
}

.TrainingSummary_metricSingle__NpiER {
  grid-column: 1 / -1;
}

.TrainingSummary_metricCard__xnmvw {
  background: var(--brand-surface);
  border-radius: 12px;
  border: 1px solid rgba(var(--brand-primary-rgb), 0.1);
  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);
  height: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  position: relative;
}

.TrainingSummary_metricSmallLabel__zhcdg {
  position: absolute;
  top: 12px;
  left: 0;
  right: 0;
  text-align: center;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.TrainingSummary_metricIcon__6xkJy {
  margin-bottom: 8px;
}

.TrainingSummary_metricValue__mDhgN {
  font-size: 24px;
  font-weight: 700;
  margin: 0;
}

.TrainingSummary_metricLabel__iuMqe {
  margin-top: 4px;
  font-size: 14px;
  color: var(--brand-text-secondary);
}

/* ---- Chart card ---- */
.TrainingSummary_chartCard__7CIE3 {
  margin-top: 30px;
}

.TrainingSummary_chartTitleRow__liEm6 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
}

.TrainingSummary_chartTitle__Sl7Ca {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

html[data-theme="dark"] .TrainingSummary_chartTitle__Sl7Ca,
body[data-theme="dark"] .TrainingSummary_chartTitle__Sl7Ca {
  color: #f8fafc;
}

.TrainingSummary_chartBox__GpELU {
  width: 100%;
  height: 390px;
  min-height: 340px;
}

@media (max-width: 600px) {
  .TrainingSummary_chartTitle__Sl7Ca {
    font-size: 17px;
    letter-spacing: -0.2px;
  }
  .TrainingSummary_chartBox__GpELU {
    height: 380px;
    min-height: 350px;
  }
}

.TrainingSummary_chartEmpty__8E4LN {
  margin: 0;
  padding: 120px 16px 40px;
  text-align: center;
  font-size: 14px;
  color: var(--brand-text-secondary);
}

/* ---- Zones legend ---- */
.TrainingSummary_zonesSection__b0Dwo {
  margin-top: 20px;
}

.TrainingSummary_zonesTitle__dTEnr {
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  color: var(--brand-text);
  margin-bottom: 12px;
}

.TrainingSummary_zoneRow__xbXx8 {
  position: relative;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  margin-bottom: 8px;
  border-radius: 4px;
}

.TrainingSummary_zoneBar__A5iVt {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  border-radius: 4px;
  opacity: 0.3;
  pointer-events: none;
}

.TrainingSummary_zoneSquare__JWKZ3 {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  flex-shrink: 0;
  z-index: 1;
}

.TrainingSummary_zoneNumber__Q9-Yy {
  width: 20px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  margin-left: 8px;
  color: var(--brand-text);
  z-index: 1;
}

.TrainingSummary_zoneName__IrBYl {
  flex: 1 1;
  margin-left: 8px;
  font-size: 14px;
  color: var(--brand-text);
  z-index: 1;
}

.TrainingSummary_zoneDuration__5PGYK {
  font-size: 12px;
  color: var(--brand-text-secondary);
  margin-left: 8px;
  z-index: 1;
}

/* ---- All players HR ranking (coach) ---- */
.TrainingSummary_rankingGroupCard__VjBmK {
  background: linear-gradient(
    165deg,
    rgba(var(--brand-primary-rgb), 0.1) 0%,
    var(--brand-surface) 52%
  );
  border: 1px solid rgba(var(--brand-primary-rgb), 0.18);
  box-shadow:
    0 8px 28px rgba(var(--brand-primary-rgb), 0.1),
    0 2px 6px rgba(0, 0, 0, 0.04);
  padding: 20px 14px 22px;
}

.TrainingSummary_rankingTitle__5Og\\+h {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: var(--brand-text);
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}

.TrainingSummary_rankingTableBlock__cMif5 {
  margin-top: 24px;
}

.TrainingSummary_rankingTableBlockFirst__-FkAU {
  margin-top: 0;
}

/* Per-metric card shell */
.TrainingSummary_rankingTableSection__koSP9 {
  position: relative;
  border-radius: 16px;
  padding: 0;
  background: var(--brand-surface);
  box-shadow:
    0 4px 14px rgba(var(--brand-primary-rgb), 0.08),
    0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(var(--brand-primary-rgb), 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.TrainingSummary_rankingTableSection__koSP9::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 4px;
  border-radius: 16px 16px 0 0;
}

.TrainingSummary_rankingSectionMax__Jv2Jv {
  --rank-accent: #e63946;
  --rank-accent-mid: #f77b84;
  --rank-accent-bright: #ff6b4a;
  --rank-surface: linear-gradient(165deg, #fff7f5 0%, #ffffff 48%);
  --rank-header-grad: linear-gradient(
    120deg,
    #ff5e4a 0%,
    #e63946 50%,
    #c42d3a 100%
  );
  --rank-row-alt: rgba(230, 57, 70, 0.06);
  --rank-pill-bg: linear-gradient(145deg, #fff0f0, #ffe4e2);
  --rank-pill-border: rgba(230, 57, 70, 0.35);
  --rank-pill-color: #9b1c26;
  --rank-top-bar: linear-gradient(90deg, #ff8a6a, #e63946, #b82533);
}

.TrainingSummary_rankingSectionMax__Jv2Jv::before {
  background: var(--rank-top-bar);
}

.TrainingSummary_rankingSectionMin__p\\+ja8 {
  --rank-accent: #0d9488;
  --rank-accent-mid: #2dd4bf;
  --rank-accent-bright: #14b8a6;
  --rank-surface: linear-gradient(165deg, #f0fdfa 0%, #ffffff 48%);
  --rank-header-grad: linear-gradient(
    120deg,
    #2dd4bf 0%,
    #0d9488 50%,
    #0f766e 100%
  );
  --rank-row-alt: rgba(13, 148, 136, 0.07);
  --rank-pill-bg: linear-gradient(145deg, #e6fffa, #d1faf5);
  --rank-pill-border: rgba(13, 148, 136, 0.38);
  --rank-pill-color: #0f5c55;
  --rank-top-bar: linear-gradient(90deg, #5eead4, #0d9488, #0f5c4c);
}

.TrainingSummary_rankingSectionMin__p\\+ja8::before {
  background: var(--rank-top-bar);
}

.TrainingSummary_rankingSectionAvg__bmOMn {
  --rank-accent: var(--brand-primary);
  --rank-accent-mid: var(--brand-primary-light);
  --rank-accent-bright: var(--brand-primary);
  --rank-surface: linear-gradient(
    165deg,
    rgba(var(--brand-primary-rgb), 0.12) 0%,
    var(--brand-surface) 48%
  );
  --rank-header-grad: linear-gradient(
    120deg,
    var(--brand-primary-light) 0%,
    var(--brand-primary) 50%,
    var(--brand-primary-dark) 100%
  );
  --rank-row-alt: rgba(var(--brand-primary-rgb), 0.08);
  --rank-pill-bg: linear-gradient(
    145deg,
    rgba(var(--brand-primary-rgb), 0.14),
    rgba(var(--brand-primary-rgb), 0.06)
  );
  --rank-pill-border: rgba(var(--brand-primary-rgb), 0.35);
  --rank-pill-color: var(--brand-primary-dark);
  --rank-top-bar: linear-gradient(
    90deg,
    var(--brand-primary-light),
    var(--brand-primary),
    var(--brand-primary-dark)
  );
}

.TrainingSummary_rankingSectionAvg__bmOMn::before {
  background: var(--rank-top-bar);
}

.TrainingSummary_rankingTableSection__koSP9:hover {
  box-shadow:
    0 8px 28px rgba(var(--brand-primary-rgb), 0.14),
    0 2px 8px rgba(0, 0, 0, 0.05);
}

.TrainingSummary_rankingTableHeaderRow__cBWm2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 14px 16px 12px;
  background: var(--rank-surface);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.TrainingSummary_rankingTableIconBadge__rjy8\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--rank-header-grad);
  color: #fff;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  flex-shrink: 0;
}

.TrainingSummary_rankingTableSubtitle__Mrwpv {
  font-size: 1rem;
  font-weight: 800;
  color: var(--brand-text);
  margin: 0;
  letter-spacing: -0.02em;
  flex: 1 1;
  min-width: 0;
}

.TrainingSummary_rankingTableTag__BWpvi {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  background: rgba(255, 255, 255, 0.9);
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.TrainingSummary_rankingTableWrap__inAd7 {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: var(--brand-surface);
}

.TrainingSummary_rankingTable__QGzDP {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
  background: var(--brand-surface);
}

/* themed column headers (gradient bar) */
.TrainingSummary_rankingTheadRow__YuiHk {
  background: var(--rank-header-grad);
  color: #fff;
}

.TrainingSummary_rankingTheadRow__YuiHk th {
  padding: 12px 10px 11px;
  font-weight: 800;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
  border: none;
}

.TrainingSummary_rankingTheadRow__YuiHk th:first-child {
  border-radius: 0;
  width: 52px;
}

.TrainingSummary_rankingTheadRow__YuiHk th:last-child {
  text-align: center;
  width: 30%;
  min-width: 72px;
}

.TrainingSummary_rankingNumCol__S6UF1 {
  text-align: center;
}

.TrainingSummary_rankingTbody__2G--M {
  color: var(--brand-text);
}

.TrainingSummary_rankingDataRow__Ietlg {
  transition: background 0.15s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.TrainingSummary_rankingTbody__2G--M tr.TrainingSummary_rankingDataRow__Ietlg:nth-child(even) {
  background: var(--rank-row-alt);
}

.TrainingSummary_rankingTbody__2G--M tr.TrainingSummary_rankingDataRow__Ietlg:hover {
  background: color-mix(in srgb, var(--rank-accent) 9%, #fff) !important;
}

.TrainingSummary_rankingTbody__2G--M tr.TrainingSummary_rankingDataRow__Ietlg:last-child {
  border-bottom: none;
}

/* Top 3: soft highlight + left accent */
.TrainingSummary_rankingDataRowTop1__mzZja {
  background: color-mix(in srgb, #ffd43b 22%, #fff) !important;
  box-shadow: inset 3px 0 0 0 #f59e0b;
}

.TrainingSummary_rankingDataRowTop2__dAO60 {
  background: color-mix(in srgb, #cbd5e1 35%, #fff) !important;
  box-shadow: inset 3px 0 0 0 #94a3b8;
}

.TrainingSummary_rankingDataRowTop3__SCF0K {
  background: color-mix(in srgb, #d4a373 20%, #fff) !important;
  box-shadow: inset 3px 0 0 0 #c2784a;
}

/* Rank + medal circle */
.TrainingSummary_rankingRankCell__BB-48 {
  text-align: center;
  width: 52px;
  padding: 10px 6px 10px 10px;
  vertical-align: middle;
}

.TrainingSummary_rankingRankBadge__fa3JR {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: #64748b;
  background: rgba(255, 255, 255, 0.85);
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.TrainingSummary_rankingMedal1__FkN1e {
  color: #92400e;
  background: linear-gradient(160deg, #fef3c7, #fde68a);
  border-color: #f59e0b;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35);
}

.TrainingSummary_rankingMedal2__NJL1e {
  color: #334155;
  background: linear-gradient(160deg, #f1f5f9, #e2e8f0);
  border-color: #94a3b8;
  box-shadow: 0 1px 4px rgba(100, 116, 139, 0.25);
}

.TrainingSummary_rankingMedal3__3rXCN {
  color: #7c2d12;
  background: linear-gradient(160deg, #fed7aa, #fbbc88);
  border-color: #ea580c;
  box-shadow: 0 1px 4px rgba(234, 88, 12, 0.22);
}

.TrainingSummary_rankingName__lDGLr {
  min-width: 100px;
  max-width: 200px;
  padding: 10px 8px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--brand-text);
}

.TrainingSummary_rankingValueCell__hou23 {
  text-align: center;
  padding: 10px 8px 10px 4px;
  vertical-align: middle;
}

.TrainingSummary_rankingValuePill__9HQcx {
  display: inline-block;
  min-width: 3rem;
  padding: 6px 12px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 15px;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  background: var(--rank-pill-bg);
  border: 1px solid var(--rank-pill-border);
  color: var(--rank-pill-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.TrainingSummary_rankingTheadRow__YuiHk th.TrainingSummary_rankingTheadRank__vAe\\+b {
  text-align: center;
}

.TrainingSummary_rankingTheadRow__YuiHk th.TrainingSummary_rankingTheadName__JJ-xq {
  text-align: left;
  padding-left: 12px;
}

.TrainingSummary_rankingError__xKhFm {
  margin: 0;
  padding: 12px 0 0;
  text-align: center;
  font-size: 14px;
  color: #c00;
}

/* ---- Video card ---- */
.TrainingSummary_videoCard__SViNq {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.TrainingSummary_videoTitleRow__vfunP {
  display: flex;
  align-items: center;
  gap: 8px;
}

.TrainingSummary_videoTitle__PzaKN {
  font-size: 16px;
  font-weight: 700;
  color: var(--brand-text);
}

.TrainingSummary_videoPlayerContainer__QaPun {
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
  border: 1px solid rgba(var(--brand-primary-rgb), 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.6);
}

.TrainingSummary_videoPlayer__HgbRE {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./src/features/trainingSummary/TrainingSummary.module.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,iBAAiB;EACjB;;;;;;cAMY;EACZ,wBAAwB;EACxB;;;;;GAKC;EACD,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;;GAKC;EACD,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb;;;;;GAKC;EACD,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb;;;;;GAKC;EACD,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qEAAqE;EACrE,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,yCAAyC;EACzC,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,eAAe;EACf,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE;IACE,oCAAoC;EACtC;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;EAChC,mBAAmB;EACnB,sDAAsD;EACtD,4CAA4C;EAC5C,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,qDAAqD;EACrD,4CAA4C;EAC5C,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kCAAkC;AACpC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,UAAU;AACZ;;AAEA,6CAA6C;AAC7C;EACE;;;;GAIC;EACD,sDAAsD;EACtD;;iCAE+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gCAAgC;EAChC;;iCAE+B;EAC/B,qDAAqD;EACrD,gBAAgB;EAChB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,gEAAgE;EAChE;;;;;GAKC;EACD,uCAAuC;EACvC,yDAAyD;EACzD,2CAA2C;EAC3C,0BAA0B;EAC1B,iEAAiE;AACnE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,6BAA6B;EAC7B,gEAAgE;EAChE;;;;;GAKC;EACD,wCAAwC;EACxC,yDAAyD;EACzD,4CAA4C;EAC5C,0BAA0B;EAC1B,iEAAiE;AACnE;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,6CAA6C;EAC7C,0CAA0C;EAC1C;;;;GAIC;EACD;;;;;GAKC;EACD,oDAAoD;EACpD;;;;GAIC;EACD,wDAAwD;EACxD,4CAA4C;EAC5C;;;;;GAKC;AACH;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;;iCAE+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA,yCAAyC;AACzC;EACE,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA;EACE,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA;EACE,4DAA4D;EAC5D,mCAAmC;AACrC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,qCAAqC;EACrC,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qDAAqD;EACrD,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,uBAAuB;EACvB,+BAA+B;EAC/B,yCAAyC;EACzC,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sDAAsD;EACtD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* ---- Page (club / BrandContext: --brand-*) ---- */\n.page {\n  min-height: 100vh;\n  font-family:\n    var(--brand-font),\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  color: var(--brand-text);\n  background: linear-gradient(\n    135deg,\n    rgba(var(--brand-primary-rgb), 0.08) 0%,\n    rgba(var(--brand-primary-rgb), 0.02) 42%,\n    var(--brand-bg) 72%\n  );\n  background-color: var(--brand-bg);\n}\n\n/* Full-screen states (loaders, errors) — same shell as club home tone */\n.fullPageShell {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(\n    135deg,\n    rgba(var(--brand-primary-rgb), 0.08) 0%,\n    rgba(var(--brand-primary-rgb), 0.02) 42%,\n    var(--brand-bg) 72%\n  );\n  background-color: var(--brand-bg);\n}\n\n.fullPageShellPadded {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: linear-gradient(\n    135deg,\n    rgba(var(--brand-primary-rgb), 0.08) 0%,\n    rgba(var(--brand-primary-rgb), 0.02) 42%,\n    var(--brand-bg) 72%\n  );\n  background-color: var(--brand-bg);\n}\n\n.fullPageStack {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 24px;\n  background: linear-gradient(\n    135deg,\n    rgba(var(--brand-primary-rgb), 0.08) 0%,\n    rgba(var(--brand-primary-rgb), 0.02) 42%,\n    var(--brand-bg) 72%\n  );\n  background-color: var(--brand-bg);\n}\n\n.shellMessage {\n  margin: 0;\n  color: var(--brand-text-secondary);\n  text-align: center;\n}\n\n.primaryCta {\n  padding: 10px 20px;\n  background: var(--brand-primary);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: var(--brand-font), sans-serif;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.primaryCta:hover {\n  background: var(--brand-primary-dark);\n}\n\n.container {\n  max-width: 480px;\n  margin: 0 auto;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.coachPlayerSelect {\n  margin-bottom: 16px;\n  text-align: left;\n}\n\n.coachPlayerSelect label {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--brand-text-secondary);\n  display: block;\n  margin-bottom: 6px;\n}\n\n.coachPlayerSelectHint {\n  margin-top: 10px;\n  font-size: 12px;\n  line-height: 1.45;\n  color: var(--brand-text-secondary);\n}\n\n/* Session context + exercise prev/next (Training Summary page) */\n.sessionContextStack {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.exerciseNav {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.4fr) minmax(0, 1fr);\n  align-items: center;\n  gap: 8px;\n  padding: 12px 14px;\n  background: var(--brand-surface);\n  border-radius: 10px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.12);\n}\n\n.exerciseNavLoading {\n  grid-column: 1 / -1;\n  text-align: center;\n  font-size: 13px;\n  color: var(--brand-text-secondary);\n}\n\n.exerciseNavBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 40px;\n  padding: 8px 10px;\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.35);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--brand-primary);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: var(--brand-font), sans-serif;\n}\n\n.exerciseNavBtn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.exerciseNavBtn:not(:disabled):hover {\n  background: rgba(var(--brand-primary-rgb), 0.08);\n}\n\n.exerciseNavBtnLabel {\n  display: none;\n}\n\n@media (min-width: 380px) {\n  .exerciseNavBtnLabel {\n    display: inline;\n  }\n}\n\n.exerciseNavCenter {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n  text-align: center;\n}\n\n.exerciseNavPos {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--brand-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.exerciseNavName {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--brand-text);\n  line-height: 1.3;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.exerciseNavJump {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  margin-top: 4px;\n  width: 100%;\n  max-width: 220px;\n}\n\n.exerciseNavJumpLabel {\n  font-size: 11px;\n  color: var(--brand-text-secondary);\n}\n\n.exerciseNavSelect {\n  width: 100%;\n  padding: 6px 8px;\n  border-radius: 8px;\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.25);\n  font-size: 13px;\n  font-family: var(--brand-font), sans-serif;\n  color: var(--brand-text);\n  background: #fff;\n}\n\n@media (max-width: 420px) {\n  .exerciseNav {\n    grid-template-columns: 44px 1fr 44px;\n  }\n\n  .exerciseNavBtn {\n    padding: 8px;\n    min-width: 44px;\n  }\n}\n\n/* ---- Header ---- */\n.header {\n  display: grid;\n  grid-template-columns: 44px 1fr 44px;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.iconBtn {\n  width: 44px;\n  height: 44px;\n  border: none;\n  background: transparent;\n  color: var(--brand-primary);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n}\n\n.iconBtn:hover {\n  background: rgba(var(--brand-primary-rgb), 0.1);\n}\n\n.title {\n  font-size: 24px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--brand-text);\n  margin: 0;\n}\n\n/* ---- Generic card ---- */\n.card {\n  background: var(--brand-surface);\n  border-radius: 12px;\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.12);\n  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);\n  padding: 16px;\n}\n\n/* ---- Exercise summary card ---- */\n.summaryCard {\n  text-align: center;\n}\n\n.summaryTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--brand-text);\n  margin: 0 0 8px;\n}\n\n.summaryType,\n.summarySubtype {\n  font-size: 14px;\n  color: var(--brand-text-secondary);\n  margin: 0;\n}\n\n.summaryDate {\n  font-size: 14px;\n  color: var(--brand-text-secondary);\n  margin-top: 12px;\n}\n\n/* ---- Metric grid ---- */\n.metricsGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 24px;\n}\n\n.metricSingle {\n  grid-column: 1 / -1;\n}\n\n.metricCard {\n  background: var(--brand-surface);\n  border-radius: 12px;\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.1);\n  box-shadow: 0 2px 10px rgba(8, 55, 90, 0.06);\n  height: 120px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 8px;\n  position: relative;\n}\n\n.metricSmallLabel {\n  position: absolute;\n  top: 12px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n}\n\n.metricIcon {\n  margin-bottom: 8px;\n}\n\n.metricValue {\n  font-size: 24px;\n  font-weight: 700;\n  margin: 0;\n}\n\n.metricLabel {\n  margin-top: 4px;\n  font-size: 14px;\n  color: var(--brand-text-secondary);\n}\n\n/* ---- Chart card ---- */\n.chartCard {\n  margin-top: 30px;\n}\n\n.chartTitleRow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.chartTitle {\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n}\n\n:global(html[data-theme=\"dark\"]) .chartTitle,\n:global(body[data-theme=\"dark\"]) .chartTitle {\n  color: #f8fafc;\n}\n\n.chartBox {\n  width: 100%;\n  height: 390px;\n  min-height: 340px;\n}\n\n@media (max-width: 600px) {\n  .chartTitle {\n    font-size: 17px;\n    letter-spacing: -0.2px;\n  }\n  .chartBox {\n    height: 380px;\n    min-height: 350px;\n  }\n}\n\n.chartEmpty {\n  margin: 0;\n  padding: 120px 16px 40px;\n  text-align: center;\n  font-size: 14px;\n  color: var(--brand-text-secondary);\n}\n\n/* ---- Zones legend ---- */\n.zonesSection {\n  margin-top: 20px;\n}\n\n.zonesTitle {\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--brand-text);\n  margin-bottom: 12px;\n}\n\n.zoneRow {\n  position: relative;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  margin-bottom: 8px;\n  border-radius: 4px;\n}\n\n.zoneBar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  border-radius: 4px;\n  opacity: 0.3;\n  pointer-events: none;\n}\n\n.zoneSquare {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  flex-shrink: 0;\n  z-index: 1;\n}\n\n.zoneNumber {\n  width: 20px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 14px;\n  margin-left: 8px;\n  color: var(--brand-text);\n  z-index: 1;\n}\n\n.zoneName {\n  flex: 1;\n  margin-left: 8px;\n  font-size: 14px;\n  color: var(--brand-text);\n  z-index: 1;\n}\n\n.zoneDuration {\n  font-size: 12px;\n  color: var(--brand-text-secondary);\n  margin-left: 8px;\n  z-index: 1;\n}\n\n/* ---- All players HR ranking (coach) ---- */\n.rankingGroupCard {\n  background: linear-gradient(\n    165deg,\n    rgba(var(--brand-primary-rgb), 0.1) 0%,\n    var(--brand-surface) 52%\n  );\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.18);\n  box-shadow:\n    0 8px 28px rgba(var(--brand-primary-rgb), 0.1),\n    0 2px 6px rgba(0, 0, 0, 0.04);\n  padding: 20px 14px 22px;\n}\n\n.rankingTitle {\n  text-align: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--brand-text);\n  margin: 0 0 8px;\n  letter-spacing: -0.02em;\n}\n\n.rankingTableBlock {\n  margin-top: 24px;\n}\n\n.rankingTableBlockFirst {\n  margin-top: 0;\n}\n\n/* Per-metric card shell */\n.rankingTableSection {\n  position: relative;\n  border-radius: 16px;\n  padding: 0;\n  background: var(--brand-surface);\n  box-shadow:\n    0 4px 14px rgba(var(--brand-primary-rgb), 0.08),\n    0 1px 3px rgba(0, 0, 0, 0.04);\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.1);\n  overflow: hidden;\n  transition: box-shadow 0.2s ease, transform 0.2s ease;\n}\n\n.rankingTableSection::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 4px;\n  border-radius: 16px 16px 0 0;\n}\n\n.rankingSectionMax {\n  --rank-accent: #e63946;\n  --rank-accent-mid: #f77b84;\n  --rank-accent-bright: #ff6b4a;\n  --rank-surface: linear-gradient(165deg, #fff7f5 0%, #ffffff 48%);\n  --rank-header-grad: linear-gradient(\n    120deg,\n    #ff5e4a 0%,\n    #e63946 50%,\n    #c42d3a 100%\n  );\n  --rank-row-alt: rgba(230, 57, 70, 0.06);\n  --rank-pill-bg: linear-gradient(145deg, #fff0f0, #ffe4e2);\n  --rank-pill-border: rgba(230, 57, 70, 0.35);\n  --rank-pill-color: #9b1c26;\n  --rank-top-bar: linear-gradient(90deg, #ff8a6a, #e63946, #b82533);\n}\n\n.rankingSectionMax::before {\n  background: var(--rank-top-bar);\n}\n\n.rankingSectionMin {\n  --rank-accent: #0d9488;\n  --rank-accent-mid: #2dd4bf;\n  --rank-accent-bright: #14b8a6;\n  --rank-surface: linear-gradient(165deg, #f0fdfa 0%, #ffffff 48%);\n  --rank-header-grad: linear-gradient(\n    120deg,\n    #2dd4bf 0%,\n    #0d9488 50%,\n    #0f766e 100%\n  );\n  --rank-row-alt: rgba(13, 148, 136, 0.07);\n  --rank-pill-bg: linear-gradient(145deg, #e6fffa, #d1faf5);\n  --rank-pill-border: rgba(13, 148, 136, 0.38);\n  --rank-pill-color: #0f5c55;\n  --rank-top-bar: linear-gradient(90deg, #5eead4, #0d9488, #0f5c4c);\n}\n\n.rankingSectionMin::before {\n  background: var(--rank-top-bar);\n}\n\n.rankingSectionAvg {\n  --rank-accent: var(--brand-primary);\n  --rank-accent-mid: var(--brand-primary-light);\n  --rank-accent-bright: var(--brand-primary);\n  --rank-surface: linear-gradient(\n    165deg,\n    rgba(var(--brand-primary-rgb), 0.12) 0%,\n    var(--brand-surface) 48%\n  );\n  --rank-header-grad: linear-gradient(\n    120deg,\n    var(--brand-primary-light) 0%,\n    var(--brand-primary) 50%,\n    var(--brand-primary-dark) 100%\n  );\n  --rank-row-alt: rgba(var(--brand-primary-rgb), 0.08);\n  --rank-pill-bg: linear-gradient(\n    145deg,\n    rgba(var(--brand-primary-rgb), 0.14),\n    rgba(var(--brand-primary-rgb), 0.06)\n  );\n  --rank-pill-border: rgba(var(--brand-primary-rgb), 0.35);\n  --rank-pill-color: var(--brand-primary-dark);\n  --rank-top-bar: linear-gradient(\n    90deg,\n    var(--brand-primary-light),\n    var(--brand-primary),\n    var(--brand-primary-dark)\n  );\n}\n\n.rankingSectionAvg::before {\n  background: var(--rank-top-bar);\n}\n\n.rankingTableSection:hover {\n  box-shadow:\n    0 8px 28px rgba(var(--brand-primary-rgb), 0.14),\n    0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n.rankingTableHeaderRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 14px 16px 12px;\n  background: var(--rank-surface);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.rankingTableIconBadge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: var(--rank-header-grad);\n  color: #fff;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\n  flex-shrink: 0;\n}\n\n.rankingTableSubtitle {\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--brand-text);\n  margin: 0;\n  letter-spacing: -0.02em;\n  flex: 1;\n  min-width: 0;\n}\n\n.rankingTableTag {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #64748b;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n}\n\n.rankingTableWrap {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  background: var(--brand-surface);\n}\n\n.rankingTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n  background: var(--brand-surface);\n}\n\n/* themed column headers (gradient bar) */\n.rankingTheadRow {\n  background: var(--rank-header-grad);\n  color: #fff;\n}\n\n.rankingTheadRow th {\n  padding: 12px 10px 11px;\n  font-weight: 800;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);\n  border: none;\n}\n\n.rankingTheadRow th:first-child {\n  border-radius: 0;\n  width: 52px;\n}\n\n.rankingTheadRow th:last-child {\n  text-align: center;\n  width: 30%;\n  min-width: 72px;\n}\n\n.rankingNumCol {\n  text-align: center;\n}\n\n.rankingTbody {\n  color: var(--brand-text);\n}\n\n.rankingDataRow {\n  transition: background 0.15s ease;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.rankingTbody tr.rankingDataRow:nth-child(even) {\n  background: var(--rank-row-alt);\n}\n\n.rankingTbody tr.rankingDataRow:hover {\n  background: color-mix(in srgb, var(--rank-accent) 9%, #fff) !important;\n}\n\n.rankingTbody tr.rankingDataRow:last-child {\n  border-bottom: none;\n}\n\n/* Top 3: soft highlight + left accent */\n.rankingDataRowTop1 {\n  background: color-mix(in srgb, #ffd43b 22%, #fff) !important;\n  box-shadow: inset 3px 0 0 0 #f59e0b;\n}\n\n.rankingDataRowTop2 {\n  background: color-mix(in srgb, #cbd5e1 35%, #fff) !important;\n  box-shadow: inset 3px 0 0 0 #94a3b8;\n}\n\n.rankingDataRowTop3 {\n  background: color-mix(in srgb, #d4a373 20%, #fff) !important;\n  box-shadow: inset 3px 0 0 0 #c2784a;\n}\n\n/* Rank + medal circle */\n.rankingRankCell {\n  text-align: center;\n  width: 52px;\n  padding: 10px 6px 10px 10px;\n  vertical-align: middle;\n}\n\n.rankingRankBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 30px;\n  height: 30px;\n  padding: 0 6px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: #64748b;\n  background: rgba(255, 255, 255, 0.85);\n  border: 1px solid rgba(0, 0, 0, 0.08);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.rankingMedal1 {\n  color: #92400e;\n  background: linear-gradient(160deg, #fef3c7, #fde68a);\n  border-color: #f59e0b;\n  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.35);\n}\n\n.rankingMedal2 {\n  color: #334155;\n  background: linear-gradient(160deg, #f1f5f9, #e2e8f0);\n  border-color: #94a3b8;\n  box-shadow: 0 1px 4px rgba(100, 116, 139, 0.25);\n}\n\n.rankingMedal3 {\n  color: #7c2d12;\n  background: linear-gradient(160deg, #fed7aa, #fbbc88);\n  border-color: #ea580c;\n  box-shadow: 0 1px 4px rgba(234, 88, 12, 0.22);\n}\n\n.rankingName {\n  min-width: 100px;\n  max-width: 200px;\n  padding: 10px 8px;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--brand-text);\n}\n\n.rankingValueCell {\n  text-align: center;\n  padding: 10px 8px 10px 4px;\n  vertical-align: middle;\n}\n\n.rankingValuePill {\n  display: inline-block;\n  min-width: 3rem;\n  padding: 6px 12px;\n  border-radius: 999px;\n  font-weight: 800;\n  font-size: 15px;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  background: var(--rank-pill-bg);\n  border: 1px solid var(--rank-pill-border);\n  color: var(--rank-pill-color);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.rankingTheadRow th.rankingTheadRank {\n  text-align: center;\n}\n\n.rankingTheadRow th.rankingTheadName {\n  text-align: left;\n  padding-left: 12px;\n}\n\n.rankingError {\n  margin: 0;\n  padding: 12px 0 0;\n  text-align: center;\n  font-size: 14px;\n  color: #c00;\n}\n\n/* ---- Video card ---- */\n.videoCard {\n  margin-top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.videoTitleRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.videoTitle {\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--brand-text);\n}\n\n.videoPlayerContainer {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #000;\n  border: 1px solid rgba(var(--brand-primary-rgb), 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.6);\n}\n\n.videoPlayer {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `TrainingSummary_page__IZAcO`,
	"fullPageShell": `TrainingSummary_fullPageShell__AV4i4`,
	"fullPageShellPadded": `TrainingSummary_fullPageShellPadded__yqgHM`,
	"fullPageStack": `TrainingSummary_fullPageStack__auLTi`,
	"shellMessage": `TrainingSummary_shellMessage__iTYR3`,
	"primaryCta": `TrainingSummary_primaryCta__nLFoY`,
	"container": `TrainingSummary_container__jaWfQ`,
	"coachPlayerSelect": `TrainingSummary_coachPlayerSelect__Y8p5b`,
	"coachPlayerSelectHint": `TrainingSummary_coachPlayerSelectHint__N1nh8`,
	"sessionContextStack": `TrainingSummary_sessionContextStack__audtR`,
	"exerciseNav": `TrainingSummary_exerciseNav__ObIJR`,
	"exerciseNavLoading": `TrainingSummary_exerciseNavLoading__iWAts`,
	"exerciseNavBtn": `TrainingSummary_exerciseNavBtn__4jIWP`,
	"exerciseNavBtnLabel": `TrainingSummary_exerciseNavBtnLabel__mnZgb`,
	"exerciseNavCenter": `TrainingSummary_exerciseNavCenter__J7Qum`,
	"exerciseNavPos": `TrainingSummary_exerciseNavPos__yxRRp`,
	"exerciseNavName": `TrainingSummary_exerciseNavName__GimxB`,
	"exerciseNavJump": `TrainingSummary_exerciseNavJump__sd5vf`,
	"exerciseNavJumpLabel": `TrainingSummary_exerciseNavJumpLabel__0qz0H`,
	"exerciseNavSelect": `TrainingSummary_exerciseNavSelect__7jBNe`,
	"header": `TrainingSummary_header__Uoqk5`,
	"iconBtn": `TrainingSummary_iconBtn__ktz+i`,
	"title": `TrainingSummary_title__+Gq8u`,
	"card": `TrainingSummary_card__bp222`,
	"summaryCard": `TrainingSummary_summaryCard__2bnFJ`,
	"summaryTitle": `TrainingSummary_summaryTitle__nFGQj`,
	"summaryType": `TrainingSummary_summaryType__scRAw`,
	"summarySubtype": `TrainingSummary_summarySubtype__D6bF-`,
	"summaryDate": `TrainingSummary_summaryDate__Hle40`,
	"metricsGrid": `TrainingSummary_metricsGrid__+W6wr`,
	"metricSingle": `TrainingSummary_metricSingle__NpiER`,
	"metricCard": `TrainingSummary_metricCard__xnmvw`,
	"metricSmallLabel": `TrainingSummary_metricSmallLabel__zhcdg`,
	"metricIcon": `TrainingSummary_metricIcon__6xkJy`,
	"metricValue": `TrainingSummary_metricValue__mDhgN`,
	"metricLabel": `TrainingSummary_metricLabel__iuMqe`,
	"chartCard": `TrainingSummary_chartCard__7CIE3`,
	"chartTitleRow": `TrainingSummary_chartTitleRow__liEm6`,
	"chartTitle": `TrainingSummary_chartTitle__Sl7Ca`,
	"chartBox": `TrainingSummary_chartBox__GpELU`,
	"chartEmpty": `TrainingSummary_chartEmpty__8E4LN`,
	"zonesSection": `TrainingSummary_zonesSection__b0Dwo`,
	"zonesTitle": `TrainingSummary_zonesTitle__dTEnr`,
	"zoneRow": `TrainingSummary_zoneRow__xbXx8`,
	"zoneBar": `TrainingSummary_zoneBar__A5iVt`,
	"zoneSquare": `TrainingSummary_zoneSquare__JWKZ3`,
	"zoneNumber": `TrainingSummary_zoneNumber__Q9-Yy`,
	"zoneName": `TrainingSummary_zoneName__IrBYl`,
	"zoneDuration": `TrainingSummary_zoneDuration__5PGYK`,
	"rankingGroupCard": `TrainingSummary_rankingGroupCard__VjBmK`,
	"rankingTitle": `TrainingSummary_rankingTitle__5Og+h`,
	"rankingTableBlock": `TrainingSummary_rankingTableBlock__cMif5`,
	"rankingTableBlockFirst": `TrainingSummary_rankingTableBlockFirst__-FkAU`,
	"rankingTableSection": `TrainingSummary_rankingTableSection__koSP9`,
	"rankingSectionMax": `TrainingSummary_rankingSectionMax__Jv2Jv`,
	"rankingSectionMin": `TrainingSummary_rankingSectionMin__p+ja8`,
	"rankingSectionAvg": `TrainingSummary_rankingSectionAvg__bmOMn`,
	"rankingTableHeaderRow": `TrainingSummary_rankingTableHeaderRow__cBWm2`,
	"rankingTableIconBadge": `TrainingSummary_rankingTableIconBadge__rjy8+`,
	"rankingTableSubtitle": `TrainingSummary_rankingTableSubtitle__Mrwpv`,
	"rankingTableTag": `TrainingSummary_rankingTableTag__BWpvi`,
	"rankingTableWrap": `TrainingSummary_rankingTableWrap__inAd7`,
	"rankingTable": `TrainingSummary_rankingTable__QGzDP`,
	"rankingTheadRow": `TrainingSummary_rankingTheadRow__YuiHk`,
	"rankingNumCol": `TrainingSummary_rankingNumCol__S6UF1`,
	"rankingTbody": `TrainingSummary_rankingTbody__2G--M`,
	"rankingDataRow": `TrainingSummary_rankingDataRow__Ietlg`,
	"rankingDataRowTop1": `TrainingSummary_rankingDataRowTop1__mzZja`,
	"rankingDataRowTop2": `TrainingSummary_rankingDataRowTop2__dAO60`,
	"rankingDataRowTop3": `TrainingSummary_rankingDataRowTop3__SCF0K`,
	"rankingRankCell": `TrainingSummary_rankingRankCell__BB-48`,
	"rankingRankBadge": `TrainingSummary_rankingRankBadge__fa3JR`,
	"rankingMedal1": `TrainingSummary_rankingMedal1__FkN1e`,
	"rankingMedal2": `TrainingSummary_rankingMedal2__NJL1e`,
	"rankingMedal3": `TrainingSummary_rankingMedal3__3rXCN`,
	"rankingName": `TrainingSummary_rankingName__lDGLr`,
	"rankingValueCell": `TrainingSummary_rankingValueCell__hou23`,
	"rankingValuePill": `TrainingSummary_rankingValuePill__9HQcx`,
	"rankingTheadRank": `TrainingSummary_rankingTheadRank__vAe+b`,
	"rankingTheadName": `TrainingSummary_rankingTheadName__JJ-xq`,
	"rankingError": `TrainingSummary_rankingError__xKhFm`,
	"videoCard": `TrainingSummary_videoCard__SViNq`,
	"videoTitleRow": `TrainingSummary_videoTitleRow__vfunP`,
	"videoTitle": `TrainingSummary_videoTitle__PzaKN`,
	"videoPlayerContainer": `TrainingSummary_videoPlayerContainer__QaPun`,
	"videoPlayer": `TrainingSummary_videoPlayer__HgbRE`
};
export default ___CSS_LOADER_EXPORT___;
